export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-7195118.984c692c.jpg";